// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
import React from 'react';
export function getReactMajorVersion() {
    var _a;
    const versionString = (_a = React.version) === null || _a === void 0 ? void 0 : _a.split('.')[0];
    return versionString ? parseInt(versionString, 10) : NaN;
}
//# sourceMappingURL=react-version.js.map